import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanDeactivate } from '@angular/router';
import * as constantValues from '../../../contracts/common/const.model';
import * as appGlobals from '../../../master/globals';

@Injectable()
export class ChangeTrackerService implements CanDeactivate<any> {
    get unSavedChanges(): boolean {
        return appGlobals.changeState.hasChanges;
    }
    set unSavedChanges(value: boolean) {
        appGlobals.changeState.hasChanges = value;
    }

    constructor(private router: Router) {
        const me = this;
        window.onbeforeunload = function(e) {
            if (me.unSavedChanges) {
                const dialogText = constantValues.UNSAVED_MESSAGE;
                e.returnValue = dialogText;
                return dialogText;
            }
        };
    }

    canDeactivate(
        component: any,
        currentRoute: ActivatedRouteSnapshot,
        currentState: RouterStateSnapshot,
        nextState: RouterStateSnapshot
      ): Observable<boolean>|Promise<boolean>|boolean {
        if (!this.unSavedChanges) {
            return true;
        } else {
            if (window.confirm(constantValues.UNSAVED_MESSAGE)) {
                this.unSavedChanges = false;
                return true;
            }
        }

        return false;
    }
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/shared/guards/change-tracker/change-tracker.service.ts